var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStyles = function SvgStyles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M15.887 2.98h-5.274L8.328 5.5H3.23v15h20.04v-15h-5.098zM17 .52l2.285 2.46h3.985c1.347 0 2.46 1.172 2.46 2.52v15c0 1.348-1.113 2.52-2.46 2.52H3.23c-1.347 0-2.46-1.172-2.46-2.52v-15c0-1.348 1.113-2.52 2.46-2.52h3.985L9.5.52zm-3.75 8.73c-2.05 0-3.75 1.7-3.75 3.75s1.7 3.75 3.75 3.75S17 15.05 17 13s-1.7-3.75-3.75-3.75m0-2.52A6.277 6.277 0 0 1 19.52 13a6.277 6.277 0 0 1-6.27 6.27A6.277 6.277 0 0 1 6.98 13a6.277 6.277 0 0 1 6.27-6.27"
  })));
};
export default SvgStyles;